import dropdownInput from "./dropdown-input";

export default new class Popup {
    constructor() {
        this.initHandler();
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        let _this = this;

        document.addEventListener('click', function(e) {
            let link = null;
            //открытие попапа
            if (link = e.target.closest('.popup-link')) {
                e.preventDefault();
                let id = link.getAttribute('id');
                if(!id) {
                    id = link.getAttribute('data-id');
                }
                let tab = link.getAttribute('tab');
                if(id) {
                    _this.popupMenuOpen(id, tab);

                    // запоминаем какой попап показать в конце (например после регистрации в корзине)
                    _this.nextPopup = link.dataset.nextPopup || _this.nextPopup;
                }
                else {
                    console.log('такого модального окна не существует');
                }
                return;
            }

            if (_this.isOpen) {

                if (e.target.closest('.popup__close')) {
                    this.nextPopup = null;
                    _this.popupMenuClose();
                }
                if (e.target.closest('.popup-close-btn')) {
                    this.nextPopup = null;
                    _this.popupMenuClose();
                }


                if (e.target.closest('.popup__content') ) {
                    // клик внутри элемента
                    return;
                }

                _this.nextPopup = null;
                _this.popupMenuClose();
            }

        });

        document.addEventListener("DOMContentLoaded", () => {
            if(document.querySelector('.popup#laplandia-promotion')) {
                if(!localStorage.getItem('laplandia_promotion')) {
                    this.popupMenuOpen('laplandia-promotion')
                    localStorage.setItem('laplandia_promotion', true)
                }
            }
        })
    }

    //закрытие попапа
    popupMenuClose() {
        document.querySelectorAll('.popup').forEach((el) => {
            let excludeResetOnClose = [
                'popup-search',
                'filter-popup',
                'feedback'
            ];

            el.style.display="none";
            const formEl = el.querySelector('form');
            if (formEl && !excludeResetOnClose.includes(el.id)) {
                formEl.reset();
            }
            document.body.classList.remove('oc-hidden');
        });
        this.isOpen = false;
    }
    //открытие попапа
    popupMenuOpen(id, tab = null) {
        this.popupMenuClose();
        this.isOpen = true;
        const popup = document.querySelector('.popup[id="'+id+'"]');

        popup.style.display="flex";
        document.body.classList.add('oc-hidden');

        if(tab) {
            popup.querySelectorAll('[data-tab]').forEach((el) => {
                el.classList.remove('active')
            });
            popup.querySelectorAll('[data-tab="'+tab+'"]').forEach((el) => {
                el.classList.add('active')
            });
        }

        if (id == 'filter-popup') {
            dropdownInput.updateAll();
        }

        if (id == 'popup-search') {
            popup.querySelector('.search-input[name="query_main_search"]').focus();
        }
    }

}();